import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { BrowserRouter } from "react-router-dom";
import Auth from "@aws-amplify/auth"
import * as Sentry from "@sentry/react";

Auth.configure({
    Auth: {
        mandatorySignIn: true,
        region: import.meta.env.VITE_AWS_REGION,
        userPoolId: import.meta.env.VITE_USER_POOL_ID,
        userPoolWebClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
    },
})

if (import.meta.env.VITE_ENV === "production") {
    Sentry.init({
        dsn: "https://d49cff454d6a7147e6227ab39780479c@o4510781758898176.ingest.us.sentry.io/4510833594925056",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.browserProfilingIntegration(),
            Sentry.replayIntegration(),
            Sentry.consoleLoggingIntegration({ levels: ["error", "warn"] }),
            Sentry.browserSessionIntegration(),
            Sentry.httpClientIntegration(),
        ],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        // tracePropagationTargets: [/^https:\/\/backend\.helpia\.com(\/.*)?$/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        // Set profilesSampleRate to 1.0 to profile every transaction.
        // Since profilesSampleRate is relative to tracesSampleRate,
        // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
        // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
        // results in 25% of transactions being profiled (0.5*0.5=0.25)
        profilesSampleRate: 1.0,
        _experiments: {
            enableLogs: true,
            beforeSendLog: (log) => {
                if (log.level === "info") {
                    // Filter out all info logs
                    return null;
                }
                return log;
            },
        },
    });
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
)
